import React from 'react';
import { array, string, bool, func, shape } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { translate } from 'react-i18next';

import { BaseHeader } from '@snapask/common-components';
import Link from '@dragonfruit/components/Link';

import { getProfileInfo, getRole } from '@dragonfruit/redux/profile';

import {
  getZendeskFAQLink,
  getOfferingList,
  getMultipleOfferingMode,
  getCampaignLinks,
  getShowLiveInstructorBtn,
  getShowCourseInstructorBtn,
} from '@dragonfruit/redux/siteInfo';
import { logout } from '@dragonfruit/redux/auth';
import {
  generateOfficialSiteURL,
  generateAcademyURL,
  generateQuestionAskURL,
} from '@dragonfruit/redux/navigation';
import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';

import {
  NAV_RC_ALL_INSTRUCTOR_CLICK,
  NAV_COURSE_ALL_INSTRUCTOR_CLICK,
  HOME_DOWNLOAD_CLICK,
} from '@dragonfruit/constants/gtmEvents';
import {
  COURSE_INSTRUCTOR_LIST,
  REGULAR_CLASS_INSTRUCTOR_LIST,
} from '@dragonfruit/constants/navigation';
import { ANDROID, IOS } from '@dragonfruit/constants/appDownloadType';
import { getRegion } from '@dragonfruit/redux/locale';

function SnapaskHeader({
  appRegion,
  getAcademyURL,
  getOfficialSiteURL,
  getQuestionAskURL,
  isAuthenticated,
  handleClickLogout,
  userInfo,
  offerings,
  t,
  zendeskFAQUrl,
  multipleOfferingMode,
  campaignLinks,
  showCourseInstructorBtn,
  showLiveInstructorBtn,
  sendGtmEvent,
}) {
  const onClickNavItem = key => {
    const eventNameMapping = {
      [REGULAR_CLASS_INSTRUCTOR_LIST]: NAV_RC_ALL_INSTRUCTOR_CLICK,
      [COURSE_INSTRUCTOR_LIST]: NAV_COURSE_ALL_INSTRUCTOR_CLICK,
    };

    sendGtmEvent({
      eventName: eventNameMapping[key],
    });
  };

  const onIosDownloadClick = () => {
    sendGtmEvent({
      eventName: HOME_DOWNLOAD_CLICK,
      data: {
        region: appRegion,
        type: IOS,
      },
    });
  };

  const onAndroidDownloadClick = () => {
    sendGtmEvent({
      eventName: HOME_DOWNLOAD_CLICK,
      data: {
        region: appRegion,
        type: ANDROID,
      },
    });
  };

  return (
    <BaseHeader
      getAcademyURL={getAcademyURL}
      getOfficialSiteURL={getOfficialSiteURL}
      getQuestionAskURL={getQuestionAskURL}
      LinkComponent={Link}
      isAuthenticated={isAuthenticated}
      onClickLogout={handleClickLogout}
      userInfo={userInfo}
      zendeskFAQUrl={zendeskFAQUrl}
      offerings={offerings}
      multipleOfferingMode={multipleOfferingMode}
      campaignLinks={campaignLinks}
      showLiveInstructorLink={showLiveInstructorBtn}
      showCourseInstructorLink={showCourseInstructorBtn}
      t={t}
      onClick={onClickNavItem}
      onIosDownloadClick={onIosDownloadClick}
      onAndroidDownloadClick={onAndroidDownloadClick}
    />
  );
}

SnapaskHeader.propTypes = {
  appRegion: string.isRequired,
  campaignLinks: shape({
    regularClass: array,
    course: array,
    activity: array,
  }).isRequired,
  getAcademyURL: func.isRequired,
  getOfficialSiteURL: func.isRequired,
  getQuestionAskURL: func.isRequired,
  handleClickLogout: func.isRequired,
  isAuthenticated: bool.isRequired,
  multipleOfferingMode: bool.isRequired,
  offerings: array.isRequired,
  sendGtmEvent: func.isRequired,
  showCourseInstructorBtn: bool.isRequired,
  showLiveInstructorBtn: bool.isRequired,
  t: func.isRequired,
  zendeskFAQUrl: string.isRequired,
  userInfo: shape({
    avatarUrl: string,
    username: string,
    role: string,
    roleStatus: string,
  }),
};

export default compose(
  translate(['navigation']),
  connect(
    state => ({
      isAuthenticated: !!state.auth.token,
      userInfo: {
        avatarUrl: getProfileInfo(state, 'avatar'),
        username: getProfileInfo(state, 'username'),
        role: getRole(state),
        roleStatus: getProfileInfo(state, 'roleStatus'),
      },
      zendeskFAQUrl: getZendeskFAQLink(state),
      offerings: getOfferingList(state),
      multipleOfferingMode: getMultipleOfferingMode(state),
      getAcademyURL: generateAcademyURL(state),
      getOfficialSiteURL: generateOfficialSiteURL(state),
      getQuestionAskURL: generateQuestionAskURL(state),
      campaignLinks: getCampaignLinks(state),
      showLiveInstructorBtn: getShowLiveInstructorBtn(state),
      showCourseInstructorBtn: getShowCourseInstructorBtn(state),
      appRegion: getRegion(state),
    }),
    {
      handleClickLogout: logout,
      sendGtmEvent,
    }
  )
)(SnapaskHeader);



// WEBPACK FOOTER //
// ./app/components/SnapaskHeader/SnapaskHeader.jsx